// @flow
import React, {Component} from 'react';
import './CandidateTracker.css';
import FlipMove from 'react-flip-move';
import ReactTooltip from 'react-tooltip';
import TransitiveNumber from 'react-transitive-number';
import type {DataSet} from './types';
import _ from 'lodash';

const IMGS = {
  hillary: "http://russia-insider.com/sites/insider/files/hillary-clinton-thumbs-up.jpg",
  trump: "http://www.theweeklings.com/wp-content/uploads/trump-ugh.jpg"
};
const NAMES = {
  hillary: 'Hillary Clinton',
  trump: 'Donald Trump'
};

export default class CandidateTracker extends Component {

  props: {
    data: DataSet,
  };

  static defaultProps = {
    data: {}
  };

  calculateWonStates<T: *, U: T[]>(data: DataSet, [c0, c1]: U): {[key: T]: string[]} {
    return _.reduce(data, (memo, value, key) => {
      const [v0, v1] = [value[c0], value[c1]];
      if (v0 && v1) {
        if (v0 > v1) memo[c0].push(key);
        if (v1 > v0) memo[c1].push(key);
      }
      return memo;
    }, {[c0]: [], [c1]: []});
  }

  // Get candidates by looking at the first state.
  getCandidates(data: DataSet) {
    const [firstKey] = Object.keys(data);
    if (!firstKey) return ['hillary', 'trump'];
    return Object.keys(data[firstKey]);
  }

  render() {
    const cs = this.getCandidates(this.props.data);
    const wins = this.calculateWonStates(this.props.data, cs);
    const sortedCandidates = _.sortBy(cs, (candidate) => -wins[candidate].length);
    const children = _.map(sortedCandidates, (candidate) => (
      <div className={`candidate-facts ${candidate}`} key={candidate}>
        <CandidateWrapper name={NAMES[candidate]} imgURL={IMGS[candidate]} states={wins[candidate]} />
      </div>
    ));

    return (
      <FlipMove className="candidate-tracker card" easing="ease-in-out">
        {children}
      </FlipMove>
    );
  }
}

type CandidateWrapperProps = {imgURL: string, name: string, states: string[], children?: React.Element<any>};
function CandidateWrapper({imgURL, name, states}: CandidateWrapperProps) {
  return (
    <div>
      <div className="image-wrapper">
        <img src={imgURL} alt="candidate-face" />
      </div>
      <h2>{name}</h2>
      <div className="fact-wrapper" data-tip={states.join(', ')}>
        Winning <br />
        <div className="wins">
          <TransitiveNumber enableInitialAnimation={true}>{states.length}</TransitiveNumber>
        </div>
        State{states.length !== 1 ? 's' : ''}
        <ReactTooltip />
      </div>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/CandidateTracker.js
 **/